"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTemplateColors = exports.getColorConfig = void 0;
const getColorConfig = (config) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const template = ((_b = (_a = config.fields) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.content) || 0;
    const colorStore = (_c = config.images) === null || _c === void 0 ? void 0 : _c.reduce((prevImg, currImg, imgIdx) => {
        prevImg[imgIdx] = currImg.templates.reduce((prevTemp, currTemp, tempIdx) => {
            var _a;
            prevTemp[tempIdx] = ((_a = currTemp.colorsOptions) === null || _a === void 0 ? void 0 : _a.length)
                ? currTemp.colorsOptions
                : exports.defaultTemplateColors[tempIdx];
            return prevTemp;
        }, []);
        return prevImg;
    }, []);
    const imageIndex = ((_d = config === null || config === void 0 ? void 0 : config.images) === null || _d === void 0 ? void 0 : _d.findIndex(({ src }) => { var _a, _b; return src === ((_b = (_a = config.fields) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.content); })) || 0;
    const imageColors = (colorStore === null || colorStore === void 0 ? void 0 : colorStore[imageIndex]) || exports.defaultTemplateColors;
    const templateColors = imageColors === null || imageColors === void 0 ? void 0 : imageColors[template];
    const selectedColors = (_h = (_g = (_f = (_e = config.fields) === null || _e === void 0 ? void 0 : _e.colors) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g[imageIndex]) === null || _h === void 0 ? void 0 : _h[template];
    const generateUpdatedColors = (colorOption) => {
        var _a, _b;
        const colors = ((_b = (_a = config === null || config === void 0 ? void 0 : config.fields) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.content) || [];
        const selectedTemplateColors = colors[imageIndex] || {};
        selectedTemplateColors[template] = colorOption;
        colors.splice(imageIndex, 1, selectedTemplateColors);
        return colors;
    };
    return {
        imageColors,
        imageIndex,
        templateColors,
        selectedColors,
        generateUpdatedColors,
    };
};
exports.getColorConfig = getColorConfig;
exports.defaultTemplateColors = {
    0: [
        {
            dark: "#0078d4",
        },
        {
            dark: "#3c308b",
        },
        {
            dark: "#572f69",
        },
        {
            dark: "#652546",
        },
    ],
    1: [
        {
            dark: "#241451",
            light: "#755dbb",
        },
        {
            dark: "#652546",
            light: "#eea6cb",
        },
        {
            dark: "#572f69",
            light: "#d29eea",
        },
        {
            dark: "#3c308b",
            light: "#c0baea",
        },
    ],
    2: [
        {
            light: "#909ca9",
            dark: "#38434e",
        },
        {
            dark: "#652546",
            light: "#eea6cb",
        },
        {
            dark: "#572f69",
            light: "#d29eea",
        },
        {
            dark: "#3c308b",
            light: "#c0baea",
        },
    ],
    3: [
        {
            dark: "#7158b9",
        },
        {
            dark: "#3c308b",
        },
        {
            dark: "#572f69",
        },
        {
            dark: "#652546",
        },
    ],
    4: [
        {
            dark: "#0078d4",
        },
        {
            dark: "#3c308b",
        },
        {
            dark: "#572f69",
        },
        {
            dark: "#652546",
        },
    ],
};
//# sourceMappingURL=colors.js.map